<template>
  <div class="container-fluid p-0 ">
    <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">Crear expediente</p>
    </div>
    <div class="info mt-4">
         <div class='mt-2'>
            Cargador: <p class = 'grey d-inline'> {{cargador}}</p>
        </div>
         <div class ='mt-2' >
            Nº de contenedores:  <p class = 'grey d-inline'> {{containerNumber}}</p>
        </div>
        <div class ='mt-2' >
            Tamaño de contenedores:  <p class = 'grey d-inline'> {{containerSize}}</p>
        </div>
        <div class ='mt-2' >
            Tipo de mercancía:  <p class = 'grey d-inline'> {{merchandiseType}}</p>
        </div>
        <div class ='mt-2' >
            Mercancía peligrosa:  <p class = 'grey d-inline'> {{dangerous}}</p>
        </div>
        <div class ='mt-2' >
            Toneladas:  <p class = 'grey d-inline'> {{weight}}</p>
        </div>
        <div class ='mt-2' >
            Destino:  <p class = 'grey d-inline'> {{destination}}</p>
        </div>
    </div>
   <div class="w-100 layout-selected-pickup">
        <div class="form-group">
            <label for="nombre">Naviera</label>
            <select class="select-input" v-model="selectedNaviera">
                <option  v-for="(naviera, index) in navieras" :key="index" >{{naviera}}</option>
            </select>
        </div>
     </div>
     <div class="layout-selected-pickup">
        <div class="form-group mt-2">
            <button type="submit" class="btn-general" @click="createExpedient()">
                CREAR Y AVISAR NAVIERA
            </button>
        </div>
     </div>
     <confirmModal v-if="modalVisible" message="Expediente generado. Se notificará a Naviera."></confirmModal>
     
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import { getData, setData, putData, updateAction } from '@/services/api'
import { autoAssignContainer } from '@/services/automatedActions'
import confirmModal from '@/components/confirmModal'

export default {
  name: 'CreateExpedient',
  components: { confirmModal },
  data() {
    return {
        container_data: null,

        cargador: 'Linasa',
        containerNumber: null,
        containerSize: '',
        merchandiseType: '',
        weight: '',
        destination: '',
        dangerous: '',
        navieras: ['Maersk'],
        selectedNaviera: 'Maersk',

        modalVisible: false
    }
  },
  computed: { 
    ...mapGetters("user",{
      authorized: 'authorized',
    }),
    ...mapGetters("container",{
      container_id: 'container_id',
      actions: 'action_list'
    }),  
  },
  mounted () {
    this.$store.commit('set_view_name', ['CREAR EXPEDIENTE'])
    this.getReservationInfo()
  },
  methods: {
    getReservationInfo: function() {
      
      getData('expedientes/' + this.container_id).then(res => {
        this.container_data = res.data
        
        if(res.data.contenedores[0]){
          if(res.data.contenedores[0].dangerousMerchandise == true){
            this.dangerous = "Sí"
          }
          else {
            this.dangerous = "No"
          }
          this.merchandiseType = res.data.contenedores[0].naturaleza
          this.weight = (res.data.contenedores[0].weight / 1000) + " Tn"
        }
        
        this.containerNumber = res.data.containerNumber
        this.containerSize = res.data.containerSize      
        this.destination = res.data.destination
        
      })
    },
    createExpedient: function() {
      // API - Assign "Naviera" to expedient
      this.container_data["naviera"] = {
        "name": "Maersk", // This shoud be get dynamically (this.selectedNaviera), but the way the API works right now we must force some known parameters
        "id": 4
      }
      setData('expedientes/', this.container_data).then(res => {
        // Change expedient state in backend
        var now = new Date(); 
        updateAction(this.container_id, "CREACION_DE_EXPEDIENTE", now, this.actions.stage1.action_list.action002.apiId).then(res => {
          updateAction(this.container_id, "ASIGNACION_DE_CONTENEDOR", "pending", '').then(res => {

            // Simulate next action
            autoAssignContainer(this.container_data)
            
            // Display confirm modal
            this.modalVisible = true
          })
        })
      })      
    },
  }
}
</script>

<style lang= "scss" scoped >
 .info {
    padding: 0px 0px 20px 30px;
    border-bottom: 2px solid $grey1;
 }



</style>